import { isEmpty, isNil } from "lodash";
import { isSliderFilterParam } from "@circle-react-shared/Filter/FilterTypes/SliderFilter";
import {
  isArrayComparatorParam,
  requireValueByFilterType as requireValueByArrayFilterType,
} from "../Filter/FilterTypes/ArrayFilterComparator/arrayComparators";
import {
  isStringComparatorParam,
  requireValueByFilterType as requireValueByStringFilterType,
} from "../Filter/FilterTypes/InputFilterComparator/stringComparators";
import type { BaseFilter } from "./types";

/**
 * Check if value is empty, so that it can be removed.
 */
export function getIsValueEmpty(filterParam: BaseFilter) {
  /* If there are more cases like this, consider moving the function to passed object itself instead of modifying here. */
  if (isSliderFilterParam(filterParam)) {
    const gteValue = filterParam.gte;
    const lteValue = filterParam.lte;
    return !!(isNil(gteValue) && isNil(lteValue));
  }
  if (
    isStringComparatorParam(filterParam) &&
    !requireValueByStringFilterType(filterParam.filter_type)
  ) {
    return false;
  }

  if (
    isArrayComparatorParam(filterParam) &&
    !requireValueByArrayFilterType(filterParam.filter_type)
  ) {
    return false;
  }

  const selectedValue = filterParam?.value;

  if (isNil(selectedValue)) {
    return true;
  }

  if (typeof selectedValue === "number") {
    return false;
  }

  if (typeof selectedValue === "boolean") {
    return !selectedValue;
  }

  if (isEmpty(selectedValue)) {
    return true;
  }

  return undefined;
}
